<div>
<h6 class="comment">Add comment</h6>
<div>
    <textarea class="textarea" [(ngModel)]="comment" name="comment" placeholder={{comment}}></textarea>
    <button type="button" (click)=addComment(comment) [disabled]="!comment" [ngClass]="{'btndisable': !comment, 'btn-primary': comment}">Save Comment</button>
    <button type="button" (click)=clearComment() class="clearcomment">Clear Comment</button>
</div>
</div>